import { useState } from 'react';
import { AxiosRequestConfig } from 'axios';
import useAxios from 'hooks/useAxios';
import { IAxiosResponse } from 'types';
import { uploadFile, createCSV } from 'api';
import { ICSVCreateRequest } from '../../server/types';

const useUpload = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();
  const [files, setFiles] = useState();
  const [progress, setProgress] = useState(0);

  const fileUpload = async (data: FormData) => {
    try {
      setLoading(true);

      const response = await uploadFile(data, {
        onUploadProgress: (progressEvent: Parameters<NonNullable<AxiosRequestConfig['onUploadProgress']>>[0]) =>
          setProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total)),
      });

      setFiles(response);
      setLoading(false);
      setProgress(0);

      return response;
    } catch (err) {
      setLoading(false);
      setProgress(0);
      console.log(err);
      setError((err as IAxiosResponse).message);
      return false;
    }
  };

  return [files, fileUpload, { loading, error, progress }] as const;
};

const useCreateCSV = () => {
  const [request, { loading, error }] = useAxios<string>();

  const handleCreateCSV = async (data: ICSVCreateRequest) => {
    const addedCSV = await request(createCSV(data));

    return addedCSV;
  };

  return [handleCreateCSV, { loading, error: error?.data?.message }] as const;
};

export { useUpload, useCreateCSV };
